import { isPlainObject } from '../../views/utils'

export default {
  store: {
    state: {
      env: window.location.host.includes('localhost') ? 'development' : 'production',
      colors: [...Array(8).keys()],
    },
    actions: {
      FETCH_STATE({ dispatch, getters }, { exclude = [] } = {}) {
        return dispatch('FETCH_GROUPS_MEMBERS')
          .then((userMemberships) => {
            if (!userMemberships || !userMemberships.length) {
              return Promise.resolve()
            }

            const permittedFetches = getters.flattenByUserPermissions({
              'jobcards.read': [
                'JOBCARDS',
                'EVENTS',
                'CLIENTS',
                'VEHICLES',
                'CONTACTS',
                'JOBS',
                'EXPENSES',
              ],
              'invoices.read': [
                'INVOICES',
                'FILES',
              ],
            })

            const fetchList = {
              ...([
                'GROUPS',
                // 'JOBCARDS',
                // 'EVENTS',
                // 'CLIENTS',
                // 'JOBTYPES',
                // 'JOBS',
                'USERS',
                // 'VEHICLES',
                // 'INVOICES',
                // 'FILES',
                // 'CONTACTS',
                ...permittedFetches,
              ].reduce((acc, next) => ({
                ...acc,
                [next]: { $sort: { id: -1 } },
              }), {})),
            }

            // const inGroups = {}
            // const groupIds = userMemberships.map(membership => membership.groupId)
            // const groupIdsQuery = {
            //   $in: groupIds,
            // }
            // inGroups.groupId = groupIdsQuery

            return Promise.all(Object
              .keys(fetchList)
              .filter(serviceName => !(exclude.includes(serviceName)))
              .map(serviceName => dispatch(`FETCH_${serviceName}`, fetchList[serviceName])))
          })
      },
    },
    getters: {
      colors: state => state.colors,

      splitIntoColumns: (_, { screenSizes }) => (entries, columnMap) => {
        const columnCountKey = Object.keys(columnMap).find(size => screenSizes.includes(size))
        const columnCount = columnMap[columnCountKey]
        return Array(columnCount)
          .fill()
          .map((_, columnIndex) => entries
            .filter((_, index) => (index % columnCount) === columnIndex))
      },

      // TODO: rewrite in a similar fashion as splitIntoColumns
      splitIntoRows: (_, { screenSizes }) => (entries, columnMap) => {
        const columns = isPlainObject(columnMap)
          ? columnMap[Object.keys(columnMap).find(size => screenSizes.includes(size))]
          : columnMap

        // support for objects
        const keys = isPlainObject(entries) ? Object.keys(entries) : null
        const iterable = (keys || entries)
        const rows = Array(Math.ceil(iterable.length / columns))
          .fill()
          .map(() => [])

        iterable.forEach((entry, index) => {
          const row = rows[Math.floor(index / columns)]
          if (keys) {
            row[entry] = entries[entry]
          } else {
            row.push(entry)
          }
        })

        return rows
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js